import React from 'react'
import { Container, Content, ClubWrapper } from './style.css'
import { ClubLaTercera } from '@labcon/copesa-logos'
import Scroller from './Scroller'
import { StaticImage } from 'gatsby-plugin-image'

import Fade from 'react-reveal/Fade'

const DoubleHero = () => {
  return (
    <Container>
      <Content>
        <Fade down>
          <ClubWrapper>
            <div className="body">
              <div className="logo">
                <ClubLaTercera />
              </div>
              <h2 className="pt-8 pb-8 tracking-tight morethan text-base">
                Más de 200 marcas con descuentos y experiencias para nuestros
                socios.
              </h2>

              <Scroller className="scroller">
                <div className="item">
                  <StaticImage
                    transformOptions={{
                      cropFocus: 'attention',
                      fit: 'contain',
                    }}
                    width={240}
                    height={240}
                    objectFit="contain"
                    alt="El Volcán"
                    src="./logos/el-volcan.png"
                  />
                </div>
                <div className="item">
                  <StaticImage
                    transformOptions={{
                      cropFocus: 'attention',
                      fit: 'contain',
                    }}
                    width={240}
                    height={240}
                    objectFit="contain"
                    alt="Daniels Bakery"
                    src="./logos/daniels-bakery.png"
                  />
                </div>
                <div className="item">
                  <StaticImage
                    transformOptions={{
                      cropFocus: 'attention',
                      fit: 'contain',
                    }}
                    width={240}
                    height={240}
                    objectFit="contain"
                    alt="Little Caesars Pizza"
                    src="./logos/little-caesars-pizza.png"
                  />
                </div>
                <div className="item">
                  <StaticImage
                    transformOptions={{
                      cropFocus: 'attention',
                      fit: 'contain',
                    }}
                    width={240}
                    height={240}
                    objectFit="contain"
                    alt="Pan Mostacho"
                    src="./logos/pan-mostacho.png"
                  />
                </div>
                <div className="item">
                  <StaticImage
                    transformOptions={{
                      cropFocus: 'attention',
                      fit: 'contain',
                    }}
                    width={240}
                    height={240}
                    objectFit="contain"
                    alt="Starbucks"
                    src="./logos/starbucks.png"
                  />
                </div>
                <div className="item">
                  <StaticImage
                    transformOptions={{
                      cropFocus: 'attention',
                      fit: 'contain',
                    }}
                    width={240}
                    height={240}
                    objectFit="contain"
                    alt="Cuk"
                    src="./logos/cuk.png"
                  />
                </div>
                <div className="item">
                  <StaticImage
                    transformOptions={{
                      cropFocus: 'attention',
                      fit: 'contain',
                    }}
                    width={240}
                    height={240}
                    objectFit="contain"
                    alt="Descorcha"
                    src="./logos/descorcha.png"
                  />
                </div>
                <div className="item">
                  <StaticImage
                    transformOptions={{
                      cropFocus: 'attention',
                      fit: 'contain',
                    }}
                    width={240}
                    height={240}
                    objectFit="contain"
                    alt="Uncle Fletch"
                    src="./logos/uncle-fletch.png"
                  />
                </div>
                <div className="item">
                  <StaticImage
                    transformOptions={{
                      cropFocus: 'attention',
                      fit: 'contain',
                    }}
                    width={240}
                    height={240}
                    objectFit="contain"
                    alt="Mycook Touch"
                    src="./logos/mycook-touch.png"
                  />
                </div>
                <div className="item">
                  <StaticImage
                    transformOptions={{
                      cropFocus: 'attention',
                      fit: 'contain',
                    }}
                    width={240}
                    height={240}
                    objectFit="contain"
                    alt="Eufy"
                    src="./logos/eufy.png"
                  />
                </div>
                <div className="item">
                  <StaticImage
                    transformOptions={{
                      cropFocus: 'attention',
                      fit: 'contain',
                    }}
                    width={240}
                    height={240}
                    objectFit="contain"
                    alt="Entrelagos"
                    src="./logos/entrelagos.png"
                  />
                </div>
                <div className="item">
                  <StaticImage
                    transformOptions={{
                      cropFocus: 'attention',
                      fit: 'contain',
                    }}
                    width={240}
                    height={240}
                    objectFit="cover"
                    alt="Club Paula"
                    src="./logos/club-paula.png"
                  />
                </div>
              </Scroller>
              <h3 className="pt-4 pb-4 tracking-tight text-base">
                Disfrutando tus beneficios, tu suscripción no cuesta nada
              </h3>
              <h3 className="pb-8 mt-8 font-sans text-xs ">
                <strong>GASTRONOMÍA</strong> <span className="sep"></span>{' '}
                <strong>INFANTIL</strong> <span className="sep"></span>{' '}
                <strong>SERVICIOS Y DECO</strong> <span className="sep"></span>{' '}
                <strong>VIDA SANA</strong> <span className="sep"></span>{' '}
                <strong>TIEMPO LIBRE</strong> <span className="sep"></span>{' '}
                <strong>VENTAS ESPECIALES</strong>
              </h3>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://clublatercera.latercera.com/?utm_source=landingbienvenida&utm_medium=especialeslt&"
                className="btn btn-primary bg-black text-white px-8 py-4 rounded-full mt-8 mb-8 inline-block font-bold hover:bg-rojo transition duration-300 ease-in-out ">
                Ir a Club La Tercera
              </a>
            </div>
          </ClubWrapper>
        </Fade>
      </Content>
    </Container>
  )
}

export default DoubleHero
